import { Helpers } from "../../../../helpers/Helpers";
import { GetYurticiCargoByIdResponseYurticiCargoExpectedIncomeOutcome } from "../../../../models/response/yurticiCargo/GetYurticiCargoByIdResponse";

type Satir = GetYurticiCargoByIdResponseYurticiCargoExpectedIncomeOutcome;

/** Kurus altini yok sayar: sunucu da 2 haneye gore karsilastiriyor. */
const hane2 = (_deger: string | undefined) => Math.round(Helpers.toNumber(_deger ?? '0') * 100) / 100;

/**
 * Otomatik yazilmis gelir satiri elle degistirildi mi (hizmet, birim fiyat, miktar ya da doviz)?
 * Sunucudaki kural ile ayni (YurticiFiyatHesabi.ElleDegistiMi); hesaplanan alanlar (KDV, toplam) karsilastirilmaz.
 */
export const satirElleDegisti = (
    _eski: Satir,
    _yeni: { serviceId: string | undefined, unitPrice: string | undefined, quantity: string | undefined, currencyTypeId: string | undefined }
): boolean =>
    _eski.serviceId != _yeni.serviceId
    || hane2(_eski.unitPrice) != hane2(_yeni.unitPrice)
    || hane2(_eski.quantity) != hane2(_yeni.quantity)
    || _eski.currencyTypeId != _yeni.currencyTypeId;

/**
 * Gelir satirlarindan biri elle eklendi, silindi ya da degistirildiyse kargonun butun gelir satirlari elle sayilir
 * (05.10.2026): ekrandaki "Otomatik" isaretleri kalkar. Sunucu kaydederken ayni karari kendisi de verir.
 */
export const otomatikIsaretiniKaldir = (_satirlar: Satir[]): Satir[] =>
    _satirlar.map(x => x.isAutoPrice ? { ...x, isAutoPrice: false } : x);
